import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild} from '@angular/core';
import {HttpEventType, HttpResponse} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {NgForm} from "@angular/forms";
import {
  ContactType,
  CountryDefinition,
  Gender,
  V3Address,
  V3ContactEntry,
  V3PersonalSensitiveDetails,
  V3PersonDetails, V3PersonInvitationDetails,
  V3Settings
} from "../../model/v3/people";
import {PublicV3RestService} from "../../services/rest/v3/public-rest.service";
import {FileV3RestService} from "../../services/rest/v3/file-rest.service";
import {V3FileItem} from "../../model/v3/file";
import {formatDate} from "@angular/common";

@Component({
    selector: 'app-casa-personal-profile-form',
    templateUrl: './casa-personal-profile-form.component.html',
    styleUrls: ['./casa-personal-profile-form.component.scss'],
    standalone: false
})
export class CasaPersonalProfileFormComponent implements OnInit {
  uploadProgress: number = 0;
  @ViewChild('fileInput', {static: false}) fileInput;
  countries: CountryDefinition[];
  genders = [ Gender.Female, Gender.Male, Gender.Other ];
  phone: V3ContactEntry;
  skype: V3ContactEntry;
  private _contacts: V3ContactEntry[] = [];
  private _sensitiveDetails: V3PersonalSensitiveDetails
  @ViewChild('f', {static: false}) form: NgForm;

  @Input()
  role = "student"

  @Input()
  busy = false;

  @Input() isInvitation: boolean = false
  @Input() personDetails: V3PersonDetails
  @Input() settings: V3Settings
  @Input() address: V3Address = {} as V3Address
  @Input() photo: V3FileItem

  @Input()
  set contacts(value: V3ContactEntry[]) {
    this._contacts = value || []
    this.decomposeContacts()
  }

  get contacts(): V3ContactEntry[] {
    return this._contacts;
  }

  @Input()
  set sensitiveDetails(value: V3PersonalSensitiveDetails) {
    this._sensitiveDetails = value || {} as V3PersonalSensitiveDetails;
    this.convertBirthDate()
  }

  get sensitiveDetails(): V3PersonalSensitiveDetails {
    return this._sensitiveDetails;
  }

  @Output() savePerson = new EventEmitter<V3PersonInvitationDetails>()
  @Output() savePersonDetails = new EventEmitter<V3PersonDetails>();
  @Output() saveSensitiveDetails = new EventEmitter<V3PersonalSensitiveDetails>()
  @Output() saveSettings = new EventEmitter<V3Settings>()
  @Output() saveAddress = new EventEmitter<V3Address>()
  @Output() saveContacts = new EventEmitter<V3ContactEntry[]>()
  @Output() savePhoto = new EventEmitter<V3FileItem>()

  private decomposeContacts() {
    this.phone = this.contacts.find(c => c.entryType === ContactType.PHONE);
    if (this.phone == null) {
      this.phone = {} as V3ContactEntry;
      this.phone.entryType = ContactType.PHONE;
      this.phone.name = "Phone";
      this.contacts.push(this.phone);
    }
    this.skype = this.contacts.find(c => c.entryType === ContactType.SKYPE);
    if (this.skype == null) {
      this.skype = {} as V3ContactEntry;
      this.skype.entryType = ContactType.SKYPE;
      this.skype.name = "Skype";
      this.contacts.push(this.skype);
    }
  }

  constructor(
    publicV3Rest: PublicV3RestService,
    private fileV3Rest: FileV3RestService,
    @Inject(LOCALE_ID) private locale: string
  ) {
    publicV3Rest.listCountries().pipe(
      tap<CountryDefinition[]>( countries => this.countries = countries)
    ).subscribe()
  }

  isReady() {
    return this.personDetails != null &&
      this.sensitiveDetails != null &&
      this.settings != null &&
      this.address != null &&
      this.contacts != null
  }

  public onProfileImageUpload(target: EventTarget) {
    const input = target as HTMLInputElement;
    this.uploadProgress = 0;
    this.fileV3Rest.uploadFile(input.files[0]).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress ) {
        this.uploadProgress = Math.round(100 * event.loaded / event.total);
      } else if (event instanceof HttpResponse) {
        this.photo = event.body as V3FileItem;
        this.uploadProgress = null;
      }
    }, () => this.uploadProgress = null);
  }

  ngOnInit(): void {
  }

  onSave() {
    this.savePersonDetails.emit(this.personDetails);
    this.saveSensitiveDetails.emit(this.sensitiveDetails);
    this.saveSettings.emit(this.settings)
    this.saveAddress.emit(this.address)
    this.saveContacts.emit(this.contacts)
    if (this.photo) this.savePhoto.emit(this.photo)

    if(this.isInvitation) {
      let invitation = {} as V3PersonInvitationDetails
      invitation.name = this.personDetails.name
      invitation.surname = this.personDetails.surname
      invitation.photo = this.photo
      invitation.settings = this.settings
      invitation.sensitiveDetails = this.sensitiveDetails
      invitation.address = this.address
      invitation.contactEntries = this.contacts
      this.savePerson.emit(invitation)
    }
  }

  getProfilePhoto(photo: V3FileItem) {
    if (photo == null) return null;
    return 'url(' + photo?.publicAccessUrl + ')'
  }

  private convertBirthDate() {
    if (this.sensitiveDetails.birthDate) {
      this.sensitiveDetails.birthDate = formatDate(this.sensitiveDetails.birthDate, "yyyy-MM-dd", this.locale) as unknown as number;
    }
  }
}
